const DataLayer = () => {

    console.log('datalayer');

    const telecareBtnSubmit = document.getElementsByClassName('telecare-btn-js')[0];


    if(telecareBtnSubmit) {
        telecareBtnSubmit.addEventListener('click', function(el) {
            el.preventDefault();
            addToCartDataLayer(this.href);

        })
    }

    function addToCartDataLayer(linkTarget) {
        const productInfo = document.getElementsByClassName('single-product-info-js')[0];

        if(productInfo) {
            var productName = '';
            var productId = '';
            var productPrice = '';
            // var productBrand = '';
            var productCategory = '';
            // var productVariant = '';
            var productQuantity = 1;
            // Pobierz dane produktu, który został dodany do koszyka
            if(productInfo.dataset.productName) {
                productName = productInfo.dataset.productName;
            }
            if(productInfo.dataset.productId) {
                productId = productInfo.dataset.productId;
            }
            if(productInfo.dataset.productPrice) {
                productPrice = productInfo.dataset.productPrice;
            }
            if(productInfo.dataset.productCategory) {
                productCategory = productInfo.dataset.productCategory;
            }
            if(productInfo.dataset.productQuantity) {
                productQuantity = productInfo.dataset.productQuantity;
            }

            // Wywołaj zdarzenie "add_to_cart" w datalayer
            dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'currency': 'PLN',
                'items': [
                    {
                    'item_name': productName,
                    'item_id': productId,
                    'price': productPrice,
                    // 'brand': productBrand,
                    'item_category': productCategory,
                    // 'variant': productVariant,
                    'quantity': productQuantity
                    }
                ]
            }
            });

            // Przekieruj użytkownika na stronę koszyka
            setTimeout(() => {
                window.location.href = linkTarget;
            }, 1000);
        }
    }
}

export default DataLayer;